<template>
  <div class="inputs-block">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CardInputsBlock',
};
</script>

<style lang="sass" scoped>
.inputs-block
  padding: 0 0 40px
  min-height: 120px

@media screen and (max-width: 999px)
  .inputs-block
    min-height: 80px
</style>